export default "__VITE_ASSET__8789efe4__"